<template>
  <div class="container">
    <van-sticky v-show="listIsShow">
      <!-- 搜索栏 -->
      <div class="search" style="backgroundColor:#fff;">
        <div class="back" @click="back">
          <van-icon name="arrow-left" />
          <span>返回</span>
        </div>
        <div class="search_box">
          <van-search v-model="queryParams.keyword" placeholder="输入车辆品牌/车型" @search="onSearch" />
        </div>
      </div>
      <!-- 筛选区 -->
      <div class="filtrate_box">
        <!-- 排序 -->
        <div class="menu_item">
          <van-dropdown-menu>
            <van-dropdown-item v-model="queryParams.orders" :options="ordersList" @change="sortChange" />
          </van-dropdown-menu>
        </div>
        <!-- 品牌 -->
        <div class="menu_item" @click="openBrand">
          <div class="item_box">
            <div v-if="seriesName || brandName">{{ seriesName || brandName }}</div>
            <div v-else>品牌</div>
            <span class="arrow_down"></span>
          </div>
        </div>
        <!-- 价格 -->
        <div class="menu_item">
          <van-dropdown-menu>
            <van-dropdown-item ref="price" :title="priceName">
              <div class="price_menu">
                <div v-for="item in priceList" :key="item.id" :class="{ active: item.value == queryParams.price }" @click="bindPrice(item.value, item.text)">{{ item.text }}</div>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
        <!-- 更多 -->
        <div class="menu_item" @click="openMore">
          <div class="item_box">
            <div>更多</div>
            <span class="arrow_down"></span>
          </div>
        </div>
      </div>
      <!-- 总数 -->
      <div class="total">
        共找到<span>{{ total || 0 }}</span
        >辆好车
      </div>
    </van-sticky>
    <!-- 列表区 -->
    <div class="car_list" v-show="listIsShow">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getCarList" :immediate-check="false">
          <van-cell v-for="item in carList" :key="item.tradeId" style="line-height:14px" @click="toCarDetailPage(item.tradeId)">
            <div class="car_box">
              <div class="car_left">
                <img v-if="item.coverUrl" :src="item.coverUrl" />
                <img v-else lazy-load src="../assets/img/default-car.png" />
              </div>
              <div class="car_right">
                <div class="car_name" v-if="item.brandName || item.seriesName">
                  <span>{{ item.brandName || '' }}{{ item.seriesName || '' }}</span>
                </div>
                <div class="car_name" v-if="item.kindName">
                  <span>{{ item.kindName || '' }}</span>
                </div>
                <div class="car_info">
                  <span>{{ item.registMonth || '未' }}上牌 </span>
                  <span v-if="item.mileageCount && item.mileageCount != 'null'"> | {{ item.mileageCount }}万公里</span>
                </div>
                <div class="car_price">
                  <span v-if="item.showPrice">{{ isNumber(item.showPrice) ? item.showPrice + '万' : item.showPrice }}</span>
                  <span v-if="item.downPayments">首付{{ item.downPayments }}万</span>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listIsShow: true,

      // 价格相关
      priceList: [],
      isPriceActive: true,
      // 更多相关
      ordersList: [],
      // 列表相关
      carList: [],
      total: '',
      queryParams: {
        pageNo: 0,
        pageSize: 10,
        orders: '',
        price: 0,
        priceLow: '',
        priceHigh: '',
        vehicleType: 0,
        keyword: '',
        mileage: 0,
        mileageCountLow: '',
        mileageCountHigh: '',
        carAge: 0,
        carAgeLow: '',
        carAgeHigh: '',
        certifyTag: 0,
        city: '',
        brand: '',
        series: '',
        isNewcar: 0
      },
      loading: false,
      finished: false,
      refreshing: false,

      brandName: '',
      seriesName: ''
    }
  },
  created() {
    this.loadData()
    this.getCarList()
  },
  activated() {
    var query = this.$route.query
    if (query.keyword) {
      this.queryParams.keyword = query.keyword
    } else {
      this.keyword = ''
    }
    if (query.certifyTag || query.certifyTag === 0) {
      this.queryParams.certifyTag = query.certifyTag
    }
    if (query.price) {
      this.queryParams.price = query.price
    }
    if (query.brand) {
      this.queryParams.brand = query.brand
    } else if (query.brand === 0) {
      this.queryParams.brand = ''
    }
    if (query.series) {
      this.queryParams.series = query.series
    } else if (query.series === 0) {
      this.queryParams.series = ''
    }
    if (query.vehicleType || query.vehicleType === 0) {
      this.queryParams.vehicleType = query.vehicleType
    }
    if (query.mileage || query.mileage === 0) {
      this.queryParams.mileage = query.mileage
    }
    if (query.brandName) {
      this.brandName = query.brandName
    } else if (query.brand === 0) {
      this.brandName = ''
    }
    if (query.seriesName) {
      this.seriesName = query.seriesName
    } else if (query.series === 0) {
      this.seriesName = ''
    }
    if (this.$store.state.city) {
      this.queryParams.city = this.$store.state.city
    }
  },
  methods: {
    isNumber(obj) {
      return typeof obj === 'number' && !isNaN(obj)
    },
    // 获取筛选条件相关
    async loadData() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/commonBox', {
        params: {
          selectCode: 'carPrice,CarOrder',
          isshow: 'carPrice'
        }
      })
      if (data.success) {
        this.priceList = data.data.carPrice
        this.ordersList = data.data.CarOrder
      }
    },
    async getCarList() {
      var that = this
      if (this.refreshing) {
        this.refreshing = false
      }
      this.queryParams.pageNo = this.queryParams.pageNo + 1
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleList', {
        params: this.queryParams
      })
      if (data.success) {
        if (data.data.page.rows.length > 0) {
          label1: for (var car of data.data.page.rows) {
            for (var item of that.carList) {
              //去重复
              if (item.tradeId == car.tradeId) {
                continue label1 //处理下一条数据
              }
            }

            that.carList.push(car)
          }
        }
        this.loading = false
        if (this.carList.length >= data.data.page.recordCount) {
          this.finished = true
        }
        this.total = data.data.page.recordCount
      }
    },

    onRefresh() {
      this.anewGetCarLit()
    },
    // 重新请求车辆列表
    anewGetCarLit() {
      this.finished = false
      this.queryParams.pageNo = 0
      this.carList = []
      this.loading = true
      this.getCarList()
    },
    // 搜索
    onSearch() {
      this.anewGetCarLit()
    },
    // 排序切换
    sortChange(value) {
      this.queryParams.orders = this.ordersList[value].value
      this.anewGetCarLit()
    },
    // 打开品牌
    openBrand() {
      this.$router.push({
        path: '/car-brand-list',
        query: {
          brand: this.queryParams.brand,
          series: this.queryParams.series
        }
      })
    },

    // 选中价格
    bindPrice(value) {
      this.queryParams.price = value
      this.$refs.price.toggle()
    },
    // 打开更多
    openMore() {
      this.$router.push({
        path: '/more-screen',
        query: {
          vehicleType: this.queryParams.vehicleType,
          mileage: this.queryParams.mileage,
          certifyTag: this.queryParams.certifyTag
        }
      })
    },

    toCarDetailPage(id) {
      this.$router.push({
        path: '/car-detail',
        query: {
          tradeId: id
        }
      })
    },
    // 返回
    back() {
      this.$router.push({
        path: '/home'
      })
    }
  },
  computed: {
    priceName: function() {
      var index = this.priceList.findIndex(item => item.value == this.queryParams.price)
      if (index != -1) {
        if (this.priceList[index].text == '不限') {
          return '价格'
        } else {
          return this.priceList[index].text
        }
      }
      return ''
    }
  },
  watch: {
    'queryParams.keyword': function() {
      this.anewGetCarLit()
    },
    'queryParams.certifyTag': function() {
      this.anewGetCarLit()
    },
    'queryParams.price': function() {
      this.anewGetCarLit()
    },
    'queryParams.brand': function() {
      console.log(this.carList)

      this.anewGetCarLit()
    },
    'queryParams.series': function() {
      this.anewGetCarLit()
    },
    'queryParams.vehicleType': function() {
      this.anewGetCarLit()
    },
    'queryParams.mileage': function() {
      this.anewGetCarLit()
    },
    'queryParams.city': function() {
      this.anewGetCarLit()
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  .back {
    width: 15%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search_box {
    width: 80%;
  }
}
.car_list {
  .title {
    text-align: center;
  }
  .car_box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 0.8rem;
    .car_left {
      width: 35%;
      height: 100%;
    }
    .car_right {
      width: 60%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .car_name {
        height: 16px;
        font-size: 14px;
        font-weight: 700;
        line-height: 16px;
        white-space: nowrap; /*超出的空白区域不换行*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;
      }
      .car_info {
        font-size: 14px;
        color: #888;
      }
      .car_price {
        font-size: 14px;
        color: #888;
        display: flex;
        justify-content: space-between;
        & span:nth-of-type(2) {
          font-size: 16px;
          color: #f37420;
        }
      }
    }
  }
}
.total {
  padding: 6px 0px 6px 15px;
  line-height: 16px;
  height: 28px;
  background-color: #fff;
}
.filtrate_box {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  .menu_item {
    width: 25%;
    font-size: 15px;
    .item_box {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      color: #000;
      div {
        white-space: nowrap; /*超出的空白区域不换行*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis;
      }
      .arrow_down {
        border: 3px solid;
        margin-left: 6px;
        margin-top: -5px;
        border-color: transparent transparent #dcdee0 #dcdee0;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        opacity: 0.8;
      }
    }
  }
}
.brand {
  .brand_back_bar {
    position: fixed;
    width: 100%;
    z-index: 999;
  }
  .brand_title {
    background-color: #f2f2f2;
  }
  .hot_brand {
    display: flex;
    flex-direction: column;
    color: #757a7e;
    padding-top: 20px;
    .brand_box {
      .brand_img {
        width: 0.5rem;
        height: 0.4rem;
      }
    }
  }
}

.price_menu {
  padding: 15px 0;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0.15rem;
  div {
    width: 29%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    margin: 0 0.14rem 10px 0;
    background-color: #f2f2f2;
    box-sizing: content-box;
  }
}
.active {
  color: #4ca8ff !important;
  background-color: #e3ecfd !important;
}

.bottom_btn {
  position: fixed;
  bottom: 0;
  width: 3.75rem;
  height: 0.5rem;
  display: flex;
  line-height: 0.5rem;
  box-sizing: content-box;

  & div:nth-child(1) {
    width: 30%;
    text-align: center;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;
  }
  & div:nth-child(2) {
    width: 70%;
    text-align: center;
    color: #fff;
    background-color: #1989fa;
  }
}
</style>
